import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function PricingPage({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Pricing'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

